<template>
	<div class="flex wrap xs-12">
		<!-- Stepper/Left -->
		<div class="xs-last md-first bg5 br1 bc7" :class="decideStepperWidth">
			<case-steps :tree="steps" @node:select="selectStep"></case-steps>
		</div>

		<!-- Center -->
		<div class="flex xs-column xs sm-pl4 sm-pr4 sm-pb4 md-pl6 md-pb6 md-pr6">
			<div class="flex xs-center md-between mt8">
				<div class="xs-0 md-block">
					<j-button
						:type="showStepper ? 'primary' : 'bordered'"
						size="xsmall"
						class="mr2"
						@click="showStepper = !showStepper"
						>{{
							showStepper ? $t("hide_stepper") : $t("show_stepper")
						}}</j-button
					>
				</div>

				<div class="flex">
					<j-button
						:type="showEnglish ? 'primary' : 'bordered'"
						size="xsmall"
						class="mr2"
						@click="showEnglish = !showEnglish"
						>{{
							showEnglish ? $t("hide_english") : $t("show_english")
						}}</j-button
					>
					<j-button
						:type="showSimplified ? 'primary' : 'bordered'"
						size="xsmall"
						@click="showSimplified = !showSimplified"
						>{{
							showSimplified ? $t("hide_simplified") : $t("show_simplified")
						}}</j-button
					>
				</div>
			</div>

			<div class="flex xs-column md-row">
				<component
					class="xs pr1 pl1"
					v-for="(locale, i) in localesToDisplay"
					:key="i"
					:is="componentToDisplay(locale.id)"
					v-show="isLocaleDisplayed(locale.id)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CaseSteps from "../../CaseSteps/"
import JButton from "@/components/JButton/"

// schemas
import ProposedHolder from "./Schemas/ProposedHolder"
import ProposedHolderCN from "./Schemas/ProposedHolderCN"

import TaxResidency from "./Schemas/TaxResidency"
import TaxResidencyCN from "./Schemas/TaxResidencyCN"

import SourceOfWealth from "./Schemas/SourceOfWealth"
import SourceOfWealthCN from "./Schemas/SourceOfWealthCN"

import { i18n } from "@/locales/setup.js"

export default {
	components: {
		CaseSteps,
		JButton,

		// schemas
		ProposedHolder,
		ProposedHolderCN,

		TaxResidency,
		TaxResidencyCN,

		SourceOfWealth,
		SourceOfWealthCN
	},

	data() {
		return {
			showEnglish: true,
			showSimplified: false,
			showTraditional: false,
			showStepper: true,
			step: "",
			steps: [
				{
					id: "ProposedHolder",
					title: this.t("proposed_holder"),
					component: {
						EN: "ProposedHolder",
						CN: "ProposedHolderCN",
						HK: ""
					}
				},
				{
					id: "TaxResidency",
					title: this.t("tax_residency"),
					component: {
						EN: "TaxResidency",
						CN: "TaxResidencyCN",
						HK: ""
					}
				},
				{
					id: "SourceOfWealth",
					title: this.t("source_of_wealth"),
					component: {
						EN: "SourceOfWealth",
						CN: "SourceOfWealthCN",
						HK: ""
					}
				}
			]
		}
	},

	methods: {
		selectStep(stepToSelect) {
			// Select tab
			this.step = stepToSelect.id

			// Change selected tab
			this.steps = this.steps.map(step => ({
				...step,
				isSelected: stepToSelect.id === step.id ? true : false
			}))
		},

		componentToDisplay(locale) {
			return this.steps?.find(item => item.id === this.step)?.component?.[
				locale
			]
		},

		isLocaleDisplayed(locale) {
			return this.localesToDisplay?.find(item => item.id === locale)
				?.isDisplayed
		},

		t(key) {
			const locale = {
				"en-US": {
					proposed_holder: "Proposed Holder",
					tax_residency: "Tax Residency",
					source_of_wealth: "Source Of Wealth",
					overview: "Overview",
					proceeds_of_investment: "Proceeds of Investment",
					salary_bonus: "Salary Bonus",
					business_income: "Business Income",
					company_sale: "Company Sale",
					rental_income: "Rental Income",
					sale_of_property: "Sale of Property",
					inheritance_or_gift: "Inheritance or Gift",
					other_source_of_wealth: "Other source of Wealth",
					contingent_participant: "Contingent Participant",
					primary_beneficiaries: "Primary Beneficiaries",
					contingent_beneficiaries: "Contingent Beneficiaries",
					legal_guardian: "Legal Guardian",
					special_instructions: "Special Instructions"
				},
				"zh-HK": {
					proposed_holder: "Proposed Holder",
					overview: "概述",
					proceeds_of_investment: "投資收益",
					salary_bonus: "工資獎金",
					business_income: "業務收入",
					company_sale: "公司銷售",
					rental_income: "租金收入",
					sale_of_property: "出售財產",
					inheritance_or_gift: "財產繼承或禮物",
					other_source_of_wealth: "其他財富來源",
					contingent_participant: "臨時參與者",
					primary_beneficiaries: "主要受益人",
					contingent_beneficiaries: "臨時受益人",
					legal_guardian: "法律監護人",
					special_instructions: "特殊說明"
				},
				"zh-CN": {
					tax_residency: "税务局民",
					source_of_wealth: "财富来源",
					overview: "概述",
					proceeds_of_investment: "投资收益",
					salary_bonus: "工资奖金",
					business_income: "业务收入",
					company_sale: "公司销售",
					rental_income: "租金收入",
					sale_of_property: "出售财产",
					inheritance_or_gift: "財產继承或礼物",
					other_source_of_wealth: "其他财富来源",
					contingent_participant: "临时参与者",
					primary_beneficiaries: "主要受益人",
					contingent_beneficiaries: "临时受益人",
					legal_guardian: "法律监护人",
					special_instructions: "特殊说明"
				}
			}
			return locale[i18n.locale][key]
		}
	},

	computed: {
		currentStepProps() {
			return this.steps?.find(item => item.id === this.step)?.props
		},

		decideStepperWidth() {
			return this.showStepper ? "xs-12 md-2" : "xs-0"
		},

		decideCaseDetailWidth() {
			return this.showCaseDetails ? "xs-12 md-3 " : "xs-0"
		},

		localesToDisplay() {
			return [
				{
					id: "EN",
					isDisplayed: this.showEnglish
				},
				{
					id: "CN",
					isDisplayed: this.showSimplified
				}
				// {
				// 	id: "HK",
				// 	isDisplayed: this.showTraditional
				// }
			]
		}
	},

	created() {
		this.selectStep({ id: "ProposedHolder" })
	}
}
</script>
